export default __webpack_public_path__ + "static/media/dont_selfie.7db35208.png";